<span
  role="banner"
  aria-label="Baner sponsorski"
  class="text-white-500 text-xs uppercase font-semibold opacity-30"
>
  Baner Sponsorski
</span>
